// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Source_Sans_3_8f43e0', '__Source_Sans_3_Fallback_8f43e0'","fontStyle":"normal"},"className":"__className_8f43e0"};